module.exports = {"id":"193276","name":"Philipp Klingmann","rating":"71","photo":"./data/images/photos/0/193276.png","club":{"name":"SV Sandhausen","logo":"./data/images/clubs/SVSandhausen.png"},"positions":["DD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PhilippKlingmann0.json
// module id = 3454
// module chunks = 0